import { Injectable } from '@angular/core';
import { APIService } from './api.service';
import { Submission, SubmissionStatus } from '../interfaces/submission';
import { CrmActivity } from '../interfaces/opportunity';
import { Paged } from '../interfaces/paged';

@Injectable({ providedIn: 'root' })
export class SubmissionService extends APIService {
  listForOpportunity(oppId: number) { return this.get<{ data: Submission[] }>(`/opportunities/${oppId}/submissions`); }
  /** Tenant-wide paginated board list; params: search, status, consultant, consultant_user_id, opportunity_id, page, per_page. */
  board(params: { [k: string]: string | number } = {}) {
    const qs = Object.keys(params)
      .filter(k => params[k] !== undefined && params[k] !== null && params[k] !== '')
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(String(params[k]))}`)
      .join('&');
    return this.get<Paged<Submission>>(`/submissions/board${qs ? '?' + qs : ''}`);
  }
  show(id: number) { return this.get<Submission>(`/submissions/${id}`); }
  create(oppId: number, consultant_User_id: number) {
    return this.post(`/opportunities/${oppId}/submissions`, { consultant_User_id });
  }
  setStatus(id: number, status: SubmissionStatus, loss_reason?: string, loss_reason_note?: string, interview_at?: string) {
    return this.put(`/submissions/${id}/status`, { status, loss_reason, loss_reason_note, interview_at });
  }
  attachCv(id: number, GeneratedCv_id: number) {
    return this.post<{ GeneratedCv_id: number }, Submission>(`/submissions/${id}/cv`, { GeneratedCv_id });
  }
  setMotivation(id: number, motivation_text: string) {
    return this.put<{ motivation_text: string }, Submission>(`/submissions/${id}/motivation`, { motivation_text });
  }
  setRate(id: number, rate_offered: number | null) {
    return this.put<{ rate_offered: number | null }, Submission>(`/submissions/${id}/rate`, { rate_offered });
  }
  attachPackage(id: number, packageId: number) {
    return this.post<{ ApplicationPackage_id: number }, Submission>(`/submissions/${id}/package`, { ApplicationPackage_id: packageId });
  }
  convertToProject(id: number, start?: string, end?: string, silentStatuses: number[] = []) {
    return this.post(`/submissions/${id}/convert-to-project`, { start, end }, null, silentStatuses);
  }
  activities(id: number) { return this.get<{ data: CrmActivity[] }>(`/submissions/${id}/activities`); }
  logActivity(id: number, type: string, body: string, Contact_id?: number | null, occurred_at?: string) {
    return this.post<{ type: string; body: string; Contact_id?: number | null; occurred_at?: string }, { data: CrmActivity }>(
      `/submissions/${id}/activities`, { type, body, Contact_id, occurred_at },
    );
  }
  deleteSubmission(id: number) { return this.delete(`/submissions/${id}`); }
}
